import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { getCoprincipalAccountForMailboxInfo } from 'owa-account-source-list-store';
import { isCloudCache } from 'owa-account-source-list-internal';
import type { MailboxInfo } from 'owa-client-types';

export function isSummaryForConversationsEnabled(mailboxInfo: MailboxInfo): boolean {
    // Cloud cache accounts do not support conversation-level summarization due to a
    // server-side issue where every conversation summary request fails. Disable it
    // for these accounts until the server fix is in place.
    // TODO: https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/420878
    if (isGlobalFeatureEnabled('acct-enable-cloud-cache-bizchat')) {
        const account = getCoprincipalAccountForMailboxInfo(mailboxInfo);
        if (account && isCloudCache(account)) {
            return isGlobalFeatureEnabled('acct-summary-for-conversations-cloud-cache');
        }
    }

    return isGlobalFeatureEnabled('rp-summary-for-conversations');
}
